import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { FiUsers } from "react-icons/fi";
import { LuLightbulb } from "react-icons/lu";
import { FaInfinity } from "react-icons/fa6";
import { IoShieldCheckmarkOutline } from "react-icons/io5"
// import { transform } from '@chakra-ui/system';
// import { faLess } from '@fortawesome/free-brands-svg-icons';
import './styles/styles.css'
import { TeamMembers } from './components/teamMembers';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const AboutUs = () => {
  // const [isCardFlipped, setIsCardFlipped] = useState(false)
  const [currentVideo, setcurrentVideo] = useState(0)
  const videos = [
    "https://media.istockphoto.com/id/1399089176/video/businessman-explains-project-ideas-during-virtual-event.mp4?s=mp4-640x640-is&k=20&c=dw06uRMHNqTvrC8luDtYZ8pmaCr_d0YS6n3G9Wjm3Wo=",
    "https://videos.pexels.com/video-files/7534401/7534401-uhd_1440_2732_25fps.mp4",
    "https://videos.pexels.com/video-files/7914851/7914851-sd_640_360_30fps.mp4"
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setcurrentVideo((prevIndex) => (prevIndex + 1) % videos.length)
    }, 6000)

    return () => clearInterval(interval)
  }, [videos.length])

  return (
    <div>
      <div className="min-h-screen bg-cover bg-center bg-no-repeat relative overflow-hidden"
        style={{ backgroundImage: "url('https://media.licdn.com/dms/image/D5612AQGlWJ48Ahglpg/article-cover_image-shrink_720_1280/0/1695066913238?e=2147483647&v=beta&t=iK5_Yqcz5hmu4wfeHcNTJeVJlSjnKHFFvG7fAn3bsqA')" }}>
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black to-transparent opacity-80" />
        <div className="relative z-10 max-w-2xl mx-auto md:mx-0 md:ml-8 lg:ml-16 px-4 sm:px-6 lg:px-8 py-12 text-white">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-12"
          >
            <h1
              className="text-4xl md:text-6xl font-extrabold text-transparent text-[#d38f24] mb-4">
              Innovating Human-Technology Interaction
            </h1>
            <p className="text-xl md:text-2xl font-semibold text-blue-200 mb-6 mt-8">
              From Humble Beginnings to Global Impact
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-6"
          >
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              QualBots started as an ambitious project, a small team passionate about building more than just bots—our goal was to create interactive experiences that seamlessly integrate technology into people's lives.
            </p>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              What began as a focus on basic automation has transformed into a platform that powers intelligent systems for industries ranging from healthcare to finance, serving global clients with bespoke solutions that anticipate their every need.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-8"
          >
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Today, QualBots is at the forefront of innovation, developing tools that don't just perform tasks but evolve alongside the organizations they serve. Our journey reflects our commitment to helping businesses harness the power of automation, reducing complexity while increasing efficiency.
            </p>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed mt-4">
              Through relentless innovation, we're not just transforming businesses—we're reshaping the future of human-technology interaction. Join us in this exciting journey towards a more efficient, intelligent, and interconnected world.
            </p>
          </motion.div>
        </div>
      </div>

      {/* section 2 */}
      <div className='min-h-screen bg-gray-50'>
        <div className='max-w-6xl mx-auto  px-4 sm:px-6 lg:px-8'>

          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
          >
            <div className='mt-20 mb-14'>
              <p className='text-4xl md:text-5xl font-semibold text-[#d38f24] text-center'>Guiding Principles that Drive Us Forward</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
          >
            <div className='mb-14'>
              <p className='text-[#0b1437] text-xl  md:text-3xl font-semibold text-center'>Innovation, Integrity, and a Commitment to Change</p>
            </div>
          </motion.div>


          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
          >
            <div className='mb-20'>
              <p className='text-xl text-[#0b1437] max-w-2xl mx-auto'>
                At the heart of QualBots is a set of values that reflect our unwavering commitment to innovation and responsibility in technology.
                These guiding principles are the backbone of every decision we make, ensuring that our solutions are not only cutting-edge but also ethical and impactful.
              </p>
            </div>
          </motion.div>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-12'>

            <motion.div
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true, amount: 0.8 }}
            >
              <div className='bg-white rounded-lg px-6 py-9 shadow-xl hover:shadow-2xl transition-shadow duration-300'>
                <div className='flex items-center gap-4 mb-4'>
                  <FiUsers className='text-green-500 text-xl md:text-2xl lg:text-3xl font-semibold' />
                  <p className='text-2xl font-semibold text-[#0b1437]'>Customer-Centricity</p>
                </div>
                <p className='text-[#0b1437] text-xl'>Every solution is tailored to fit our clients’ unique needs, delivering not just technology, but value.
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true, amount: 0.8 }}
            >
              <div className='bg-white rounded-lg px-6 py-9 shadow-xl hover:shadow-2xl transition-shadow duration-300'>
                <div className='flex items-center gap-4 mb-4'>
                  <LuLightbulb className='text-[#faa926] text-xl md:text-2xl lg:text-3xl' />
                  <p className='text-2xl font-semibold text-[#0b1437]'>Innovation</p>
                </div>
                <p className='text-[#0b1437] text-xl'>Every solution is tailored to fit our clients’ unique needs, delivering not just technology, but value.
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true, amount: 0.8 }}
            >
              <div className='bg-white rounded-lg px-6 py-9 shadow-xl hover:shadow-2xl transition-shadow duration-300'>
                <div className='flex items-center gap-4 mb-4'>
                  <FaInfinity className='text-[#faa926] text-xl md:text-2xl lg:text-3xl' />
                  <p className='text-2xl font-semibold text-[#0b1437]'>Adaptability</p>
                </div>
                <p className='text-[#0b1437] text-xl'>Every solution is tailored to fit our clients’ unique needs, delivering not just technology, but value.
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true, amount: 0.8 }}
            >
              <div className='bg-white rounded-lg px-6 py-9 shadow-xl hover:shadow-2xl transition-shadow duration-300'>
                <div className='flex items-center gap-4 mb-4'>
                  <IoShieldCheckmarkOutline className='text-green-500 text-xl md:text-2xl lg:text-3xl' />
                  <p className='text-2xl font-semibold text-[#0b1437]'>Ethical Technology:</p>
                </div>
                <p className='text-[#0b1437] text-xl'>Every solution is tailored to fit our clients’ unique needs, delivering not just technology, but value.
                </p>
              </div>
            </motion.div>

          </div>
        </div>
      </div>

      {/* Section 3 */}

      <div className='w-full bg-white'>
        <div className='flex flex-col items-center pt-8 px-4 sm:px-6 lg:px-8'>
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className='text-center'>
            <h2 className='text-4xl text-[#d38f24] font-semibold mb-7'>Meet Our Team</h2>
            <p className='text-[#0b1437] text-xl font-semibold mb-7 text-center'>
              The Minds Behind the Machines ~ Diverse Talents, United by a Passion for Innovation
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className='max-w-4xl mb-8'>
            <p className='text-[#0b1437] text-lg mb-6'>
              Behind every innovative bot, there is a creative, dedicated, and dynamic team driving the engine of progress at QualBots.
              Our team is a group of passionate individuals with expertise in AI, software development, UX design, and strategic consulting, all working together to craft the perfect automation solutions for our clients.
            </p>
            <p className='text-[#0b1437] text-lg mb-8'>
              But we are more than just our skill sets—we are problem-solvers, visionaries, and lifelong learners, each bringing a unique perspective to the table. Meet the people who make QualBots the forward-thinking company it is today.
            </p>
          </motion.div>
          <div className='w-full max-w-6xl mx-auto px-4 mb-10'>
          <style>{`
        .team-slider .slick-list { margin: 0 -20px; }
        .team-slider .slick-slide > div { padding: 0 20px; }
        .team-slider .slick-track { display: flex !important; }
        .team-slider .slick-slide { height: inherit !important; display: flex !important; }
        .team-slider .slick-slide > div { width: 100%; }
      `}</style>
            <Slider className='team-slider'
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={2}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={3000}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]}>
            {TeamMembers.map((member, index) => (
              <motion.div
                key={index}
                className='h-[400px] w-full'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="relative w-full h-full group [perspective:1000px]">
                  <div className="absolute inset-0 [transform-style:preserve-3d] transition-all duration-500 ease-in-out group-hover:[transform:rotateY(180deg)]">
                    {/* Front of the card */}
                    <div className="absolute inset-0 flex flex-col justify-between rounded-2xl border border-gray-200 shadow-lg bg-white p-5 [backface-visibility:hidden]">
                      <div>
                        <img
                          className='rounded-full object-cover mx-auto w-24 h-24 sm:w-32 sm:h-32 mb-4'
                          src={member.profile}
                          alt={member.name}
                        />
                        <div className='text-center'>
                          <h3 className='text-xl sm:text-2xl font-semibold text-[#0b1437] mb-2'>{member.name}</h3>
                          <p className='text-[#d38f24] text-lg font-medium mb-2'>{member.role}</p>
                        </div>
                      </div>
                      <div className='text-center'>
                        <p className='text-gray-700 text-sm sm:text-base mb-2'>"{member.funFact}"</p>
                        <p className='text-[#0b1437] text-sm sm:text-base italic'>"{member.quote}"</p>
                      </div>
                    </div>
                    {/* Back of the card */}
                    <div className="absolute inset-0 flex flex-col justify-center rounded-2xl border border-gray-200 shadow-lg bg-white p-5 [transform:rotateY(180deg)] [backface-visibility:hidden]">
                      <div className='text-center'>
                        <h3 className='text-xl sm:text-2xl font-semibold text-[#0b1437] mb-4'>{member.name}</h3>
                        <p className='text-[#d38f24] text-lg font-medium  mb-4'>{member.bio}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
            </Slider>
          </div>
        </div>
      </div>

      {/* Section 4 */}

      <div className='container mx-auto px-4 py-10'>

        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true, amount: 0.8 }}
        >
          <p className='text-4xl text-[#0b1437] font-semibold mb-12 text-center'>Collaborating for Your Success</p>
        </motion.div>

        <div className='flex flex-col lg:flex-row  gap-14 mb-12 px-8 mt-16'>

          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
            className='lg:w-1/2'>
            <div className='aspect-video relative rounded-lg overflow-hidden'>
              <video
                className='absolute inset-0 w-full h-full object-cover'
                key={videos[currentVideo]}
                autoPlay
                loop
                muted
              >
                <source src={videos[currentVideo]} type='video/mp4' />
                Your browser does not support the video tag.
              </video>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
            className='lg:w-1/2 max-w-2xl'>

            <p className='text-[#d38f24] text-3xl font-semibold mb-6'>Our Team’s Expertise is Your Business’s Superpower</p>

            <p
              className='text-[#0b1437] text-lg sm:text-xl mb-6'
            >
              At QualBots, our people aren’t just employees—they’re experts with a passion for solving real-world problems through innovation and teamwork. Each team member plays a
              pivotal role in ensuring that your experience with QualBots is seamless, professional, and designed to exceed expectations. We believe that by combining the right technology with the right people, we can achieve extraordinary results.</p>

            <p
              className='text-[#0b1437] text-lg sm:text-xl mb-4'
            >
              Whether it’s brainstorming the next breakthrough bot, troubleshooting real-time issues, or providing long-term support, our team is dedicated to your success. Let our expertise and commitment be the key to unlocking your business’s potential through automation.
            </p>
          </motion.div>

        </div>

      </div>

      {/* Section 5 */}

      <div className='container px-2 sm:px-4 md:px-6 lg:px-10 py-10 bg-white'>

        <div className='flex flex-col sm:flex-row justify-center items-center lg:space-x-16 space-y-8 lg:space-y-0'>

          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
            className='w-full lg:w-1/2'>
            <p className='text-4xl text-[#0b1437] font-semibold mb-6'>Empowering People, Empowering Technology</p>
            <p className='text-[#d38f24] text-3xl font-semibold mb-6'>Our Team and Yours: Partners in Progress</p>
            <p className='text-gray-700 text-xl font-medium mb-5'>At QualBots, collaboration is the cornerstone of innovation. We don’t just build bots for our clients—we partner with them to create solutions that evolve and grow alongside their business.
              Our team works closely with each client to understand their unique challenges and deliver bespoke bots that meet their needs. </p>
            <p className='text-gray-700  text-xl font-medium mb-4'>The result is a partnership built on trust, innovation, and shared success.From the initial consultation to deployment and ongoing support, we’re with you every step of the way.
              Consider us not just a vendor, but an extension of your team, dedicated to pushing boundaries and finding the best solutions for your business.</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
            className='w-full lg:w-1/2 lg:space-x-16 space-y-8 lg:space-y-0 overflow-hidden' >

            <img src='https://epaouydin3q.exactdn.com/wp-content/uploads/2023/12/Remote-Team-Creativity.jpg?strip=all&lossy=1&ssl=1'
              alt='collaborative office'
              className=' object-cover w-full h-full rounded-xl' />

          </motion.div>
        </div>
      </div>

    </div >
  )
}

export default AboutUs